import styled from 'styled-components/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import palette from 'src/designSystem/variables/palette'

// The live status/narration text under a running procedure (and the summary
// placeholder), typed via useTypewriter and styled subtle + italic like TI's
// StatusDisplay.
export const OeLiveNarration = styled.span`
  display: block;
  font-size: 12px;
  font-style: italic;
  color: ${palette.neutral[600]};
  min-height: 1.5em;
`

// The "queued" placeholder row: an hourglass + text, shown in TEST DETAILS
// while a control's tests are enqueued (the status poll only surfaces
// per-procedure detail once a control starts running).
export const OeLiveLoadingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
`

// Hourglass for a control whose OE tests are queued (not yet running) — shown
// in place of the running spinner on the control/section headers and beside the
// queued TEST DETAILS message. Muted so it reads as "waiting", not active.
export const OeQueuedIcon = styled(FontAwesomeIcon)`
  font-size: 14px;
  color: ${palette.neutral[500]};
  margin-bottom: 1px;
`
